import { getRequest, postRequest, logRequest } from './api'

export async function list(size, index, searchTerm, orderBy) {
  logRequest("Show Cloud Rechnung List")
  return getRequest(`cloudRechnung/get-list/${size || 15}/${index || 0}/${searchTerm || '%20'}/${orderBy || '%20'}`)
}

export async function find(id) {
  logRequest("Show Cloud Rechnung", JSON.stringify(id))
  return getRequest(`cloudRechnung/edit/${id}`)
}

export async function save(values) {
  logRequest("Save CloudRechnung")
  return postRequest(`cloudRechnung/save`, values)
}

export function remove(values) {
  logRequest("Delete CloudRechnung", JSON.stringify(values.values))
  return postRequest(`cloudRechnung/delete`, values)
}
